// c_cart-drawer.js
// ドロワーカート用のカスタムスクリプト


/* タイトル横に単価＋メモ位置調整 */
(function () {

  // タイトル横に単価を付ける
  function addUnitPriceToTitle(root) {
    if (!root) return;

    var items = root.querySelectorAll('.ajax-cart__cart-item');
    items.forEach(function (item) {
      var titleLink = item.querySelector('.ajax-cart__title a');
      // 最初の data-cart-item-regular-price（単価）を取得
      var priceEl = item.querySelector('[data-cart-item-regular-price]');
      if (!titleLink || !priceEl) return;

      // すでに追加済みならスキップ
      if (titleLink.dataset.unitAdded === '1') return;

      var priceText = priceEl.textContent.trim();
      if (!priceText) return;

      var span = document.createElement('span');
      span.className = 'c-cart-unit-price';
      span.textContent = ' ' + priceText;

      titleLink.appendChild(span);
      titleLink.dataset.unitAdded = '1';
    });
  }

  // ご注文メモを「合計」と「利用規約チェック」の間へ移動
  function moveNoteBetweenTotalAndTerms(root) {
    if (!root) return;

    var noteWrapper = root.querySelector('.ajax-cart__info-wrapper');
    if (!noteWrapper) return;

    var summary = root.querySelector('.ajax-cart__summary-wrapper');
    if (!summary) return;

    var terms = summary.querySelector('.c_terms-agreement');
    if (!terms) return;

    // すでに「メモ → 利用規約」の順なら何もしない（無限ループ防止）
    if (noteWrapper.nextElementSibling === terms) {
      return;
    }

    // メモ全体（.ajax-cart__info-wrapper）を利用規約の直前に移動
    terms.insertAdjacentElement('beforebegin', noteWrapper);
  }

  // まとめて適用
  function enhanceDrawerCart(root) {
    addUnitPriceToTitle(root);
    moveNoteBetweenTotalAndTerms(root);
  }

  function initDrawerCartCustom() {
    var drawer = document.getElementById('slideout-ajax-cart');
    if (!drawer) return;

    var target = drawer.querySelector('.js-ajax-cart-content') || drawer;

    // 初回（ページロード直後／最初にドロワーを開いたとき用）
    enhanceDrawerCart(target);

    // Ajax カートの中身が更新されるたびに再実行
    var mo = new MutationObserver(function () {
      enhanceDrawerCart(target);
    });

    mo.observe(target, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initDrawerCartCustom();
  });
})();
